import { Box, Stack } from '@mui/material'
import { memo } from 'react'

import ProviderIcon from 'src/components/shared/exchangeProviderCard/ProviderIcon'
import CustomProgressBar from 'src/components/shared/progressBar/CustomProgressBar'
import ProgressTitle from 'src/components/shared/progressBar/ProgressTitle'

const MembershipLevel = ({
  id,
  title,
  completed,
  infoBadge,
  label,
  sx,
  titleProps,
  ...restProps
}) => {
  return (
    <Box sx={[{ gap: 2, display: 'flex', alignItems: 'center', ...sx }]}>
      <ProviderIcon size={56} src={`/assets/tiers/${id}-s.png`} />
      <CustomProgressBar
        title={
          <ProgressTitle
            name={
              <Stack spacing={1} direction='row'>
                {title}
                {infoBadge}
              </Stack>
            }
            titleProps={titleProps}
          />
        }
        label={label}
        completed={completed}
        {...restProps}
      />
    </Box>
  )
}

export default memo(MembershipLevel)
